export const interpolateTaxYear = (displayText: string, taxYear: number): string =>
  displayText.replace(/{tax_year(?:_minus_(\d+))?}/, (_, offset = 0) => (taxYear - parseInt(offset)).toString());
